/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtextnone3Inputs */

const en_aiflowtextnone3 = /** @type {(inputs: Aiflowtextnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No text`)
};

const de_aiflowtextnone3 = /** @type {(inputs: Aiflowtextnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Schrift`)
};

/**
* | output |
* | --- |
* | "No text" |
*
* @param {Aiflowtextnone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtextnone3 = /** @type {((inputs?: Aiflowtextnone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtextnone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtextnone3(inputs)
	return de_aiflowtextnone3(inputs)
});
export { aiflowtextnone3 as "aiFlowTextNone" }